import React, { useEffect, useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import { FormControl, InputLabel, MenuItem, Select, TextareaAutosize } from '@mui/material';
import Editor from 'components/editor'
const EditModal = ({ data, handleRefresh }) => {
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [svgIcon, setSvgIcon] = useState(null);
  const [description, setDescription] = useState(data.description)
  const [answer, setAnswer] = useState(data?.answer || "false");

  useEffect(() => {
    if (data?.answer !== undefined) {
      setAnswer(data.answer.toString());
    }
  }, [data]);

  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    const formData = new FormData(e.target);
    const answerValue = formData.get("answer") === "true";

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      description,
      date: e.target.date.value,
      feature: e.target.feature.value,
      public: answerValue,


    };

    console.log(payload, "payload");

    const { response } = await AppService.changelogs.update({ payload });
    console.log(response, "response")

    if (response) {
      setProcessing(false);
      closeEditProduct()
      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Tag
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>


            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Public</MDTypography>
              <FormControl fullWidth>
                <InputLabel>Public</InputLabel>
                <Select
                  name="answer"
                  value={answer} // Controlled value
                  onChange={(e) => setAnswer(e.target.value)}
                >
                  <MenuItem value="true">True</MenuItem>
                  <MenuItem value="false">False</MenuItem>
                </Select>
              </FormControl>
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">feature</MDTypography>
              <MDInput label="feature" name="feature" fullWidth defaultValue={data.feature} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Date</MDTypography>
              <MDInput label="Date" name="date" type="date" fullWidth defaultValue={data.date} />

            </MDBox>


            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
